export default {
  methods: {
    getStatutSourcing(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = 'En cours';
          break;
        case 1:
          statut = 'Clôturer';
          break;
      }
      return statut;
    },
    getStatutSourcingReponse(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = '###';
          break;
        case 1:
          statut = "Demande d'achat";
          break;
        case 2:
          statut = 'Commande';
          break;
      }
      return statut;
    },
  },
};
